import script from "./PlatmapAmenityModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatmapAmenityModal.vue?vue&type=script&setup=true&lang=ts"

import "./PlatmapAmenityModal.vue?vue&type=style&index=0&id=3fbee1aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fbee1aa"]])

export default __exports__